<template>
	<div class="incenters">
		<!-- style="border: 1px solid red;" -->
		<div style="">
			<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px"
				:src="require('@/assets/icon/icon-add.png')" @btnclick="adduser">
			</Commonbtn>
			<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px"
				:src="require('@/assets/icon/icon-update.png')" @btnclick="update">
			</Commonbtn>
			<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px"
				:src="require('@/assets/icon/icon-del.png')" @btnclick="del">
			</Commonbtn>
			<!-- :optional="stopoptional" -->
			<Commonbtn v-if="qx.enabled" opwidth="70px" top="220px" backgroundColor="#FFF" :title="stopoptionaltext"
				fontSize="14px" :src="stopoptionalimg" @btnclick="stop">
			</Commonbtn>
			<Commonbtn v-if="qx.daoc" backgroundColor="#FFF" title="导出" fontSize="14px"
				:src="require('@/assets/icon/daoc.png')" @btnclick="Export">
			</Commonbtn>
			<CommonbtnUpLoad backgroundColor="#FFF" v-if="qx.update" title="导入" fontSize="14px" @getFile="Import"
				:src="require('@/assets/icon/icon-drjys.png')">
			</CommonbtnUpLoad>
			<!-- <Commonbtn v-if="qx.assignment" backgroundColor="#FFF" title="分配角色" fontSize="14px" :src="require('@/assets/icon/iocn-userfp.png')" @btnclick="assigningroles">
      </Commonbtn>
      <Commonbtn v-if="qx.assignment" backgroundColor="#FFF" title="分配产品线" fontSize="14px" :src="require('@/assets/icon/icon-fpcpx.png')" @btnclick="assignproductline">
      </Commonbtn> -->
			<Commondown backgroundColor="#FFF" color="#333333" width="134px" fontSize="14px" :datalist="LicenseRList"
				@downs="assigningrolesOrAssignproductlineClick" types="4" titles="分配产品线"></Commondown>
			<Commonbtn backgroundColor="#FFF" v-if="qx.enabled" title="重置密码" fontSize="14px"
				:src="require('@/assets/icon/icon-passwordupdate.png')" @btnclick="czpassword">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" v-if="qx.add" title="导入经销商账号" fontSize="14px"
				:src="require('@/assets/icon/icon-drjys.png')" @btnclick="importdealerbtn">
			</Commonbtn>
			<Commondown v-if="qx.update" types="2" backgroundColor="#FFF" fontSize="14px" fontSizeDowns="10px"
				:datalist="DowloadList" @downs="Dowload" title="下载模板" :src="require('@/assets/icon/icon-add.png')">
			</Commondown>
			<i class="el-icon-arrow-down" style="line-height: 30px;color: #BFBFBF;margin-left: 40px;cursor:pointer;"
				@click="dwonlist"></i>
			<div v-if="qx.add">
				<div :class="dwonleft ? 'dwonleft' : 'dwonlefts'" style="" @click="downclick">
					导入用户产品线
				</div>
			</div>
		</div>
		<!-- style="border: 1px solid blue;" -->
		<div class="TableWidth">
			<Commontable @onRowClick="onRowClick" colnum=9 :tableData="tableData" :headerData="headerData"
				height="100%">
			</Commontable>
			<div class="pagination">
				<Pagination @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange"
					:total="total"></Pagination>
			</div>
		</div>
		<DialogFrom width="640px" title="新增产品" :dialogVisible="dialogVisiblesproduct" @cancel="cancelproduct"
			@dialogOK="dialogOKproduct">
			<div class="from">
				<template v-for="(item , index) of fromdataproduct">
					<Commondropdownlist ref="AddProductRef" :key="index" :event="item.event" :options="item.options"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @invClassChage="invClassChage"></Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="新增用户" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK">
			<div class="from">
				<template v-for="(item , index) of fromdataadd">
					<Commondropdownlist :multiple="item.multiple" :key="index" :options="item.options" ref="add"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @change3="change3"></Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<DialogFrom width="1000px" title="修改用户" :dialogVisible="dialogVisiblesedit" @cancel="canceledit"
			@dialogOK="dialogOKedit">
			<div class="from">
				<template v-for="(item , index) of fromdataedit">
					<Commondropdownlist :disabled="item.disabled" :key="index" :radio="item.radio"
						:multiple="item.multiple" ref="update" :options="item.options" :inputdata="item.inputdata"
						:title="item.title" :fontSize="item.fontSize" :color="item.color"
						:radiotitle1="item.radiotitle1" :radiotitle2="item.radiotitle2" :lablewith="item.lablewith"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width" @change3="change3"></Commondropdownlist>
				</template>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibledel" @cancel="canceldel" @dialogOK="dialogOKdel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该用户吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblestop" @cancel="cancelstop"
			@dialogOK="dialogOKstop" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要停启用该用户吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblechpassword" @cancel="cancelpassword"
			@dialogOK="dialogOKpassword" :src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
		</Dialog>
		<DialogFrom width="1000px" :OKASCAN="false" :title="`分配角色-${ CompanyNameTitle }`"
			:dialogVisible="dialogVisiblessigningroles" @cancel="cancelsigningroles" @dialogOK="dialogOKsigningroles">
			<div class="signingrolesStyle">
				<div class="left">
					<div style="width: 100%;height: 50px;border-bottom: 2px solid #E6E6E6;">
						<Commonbtn :optional="optionaladd" opwidth="70px" top="80px" backgroundColor="#FFF" title="新增"
							@btnclick="Addclick" fontSize="14px" :src="require('@/assets/icon/icon-add.png')">
						</Commonbtn>
						<Commonbtn :optional="optionaldeit" opwidth="70px" top="80px" backgroundColor="#FFF" title="修改"
							@btnclick="signeditclick" fontSize="14px" :src="require('@/assets/icon/icon-update.png')">
						</Commonbtn>
						<Commonbtn :optional="optionaldel" opwidth="70px" top="80px" backgroundColor="#FFF" title="关闭"
							@btnclick="signclaceclick" fontSize="14px" :src="require('@/assets/icon/icon-del.png')">
						</Commonbtn>
					</div>
					<div style="margin-left: -10px;">
						<Commontable @onRowClick="onRowClickfp" width="1000px" colnum=7 :tableData="tableData1"
							:headerData="headerData1">
						</Commontable>
					</div>
				</div>
				<div class="right">
					<div style="width: 100%;height: 50px;border-bottom: 2px solid #E6E6E6;">
						<Commonbtn backgroundColor="#FFF" title="应用" fontSize="14px" @btnclick="applicationclick"
							:src="require('@/assets/icon/icon-add.png')">
						</Commonbtn>
						<Commonbtn backgroundColor="#FFF" title="取消" fontSize="14px" @btnclick="NOapplicationclick"
							:src="require('@/assets/icon/icon-update.png')">
						</Commonbtn>
					</div>
					<div :disabled="rightboo">
						<Commondropdownlist ref="suptselect" :options="options" :inputdata="ptype" title="所属平台"
							fontSize="14px" color="#333333" placeholder="请选择" types=""
							inputtype="selectautocompleteHosType" width="360px" @remoteHosType="remoteHosType"
							:loading="loading"></Commondropdownlist>
						<Commondropdownlist :boxsdata="boxsdata" :checkboxdata="checkboxdata" title="所属角色"
							fontSize="14px" color="#333333" types="" inputtype="checkboxes" width="405px"
							@handleCheckedCitiesChange="handleCheckedCitiesChange"></Commondropdownlist>
					</div>
				</div>
				<div :class="{'right-s' : rightboo == false}"></div>
			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="分配产品线" :dialogVisible="dialogVisiblesassignproductline"
			@cancel="canceldialogVisiblesassignproductline" @dialogOK="dialogOKdialogVisiblesassignproductline">
			<Commondropdownlist :boxsdata="boxsdatas" top="0px" :checkboxdata="checkboxdata2" title="所属产品线"
				fontSize="14px" color="#333333" types="" inputtype="checkboxes" width="360px" widthbox="421px"
				@handleCheckedCitiesChange="handleCheckedCitiesChangecpx"></Commondropdownlist>
		</DialogFrom>
		<DialogFrom width="640px" title="导入用户产品线" :dialogVisible="dialogVisiblesasimportproductline"
			@cancel="canceldialogVisiblesasimportproductline" @dialogOK="dialogOKdialogVisiblesasimportproductline">
			<div style="display: flex;justify-content: left;">
				<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="导入"
					fontSize="14px" @getFile="SyImportInv" types="file" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<div>
					<a class="Dowload" style="margin-top: 27px;" @click="SyDowloadInv">用户产品线导入模板下载</a>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="640px" title="导入经销商账号" :dialogVisible="dialogVisiblesasjxsimportdealer"
			@cancel="canceldialogVisiblesasjxsimportdealer" @dialogOK="dialogOKdialogVisiblesjxsasimportdealer">
			<div style="display: flex;justify-content: left;">
				<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="导入"
					fontSize="14px" @getFile="SyImport" types="file" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
				<div>
					<a class="Dowload" style="margin-top: 27px;" @click="SyDowload">经销商账号导入模版下载</a>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
	</div>
</template>
<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import Commontable from '../../../components/common-table.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import Pagination from '../../../components/pagination.vue'
	import DialogFrom from '../../../components/dialog-from.vue'
	import fromdata from '../fromData/add'
	import fromdataedit from '../fromData/edit'
	import Dialog from '../../../components/dialog.vue'
	import CommonbtnUpLoad from '../../../components/common-upload.vue'
	import Commondown from '../../../components/common-down.vue'
	import {
		RolesList,
		UserInfoAdd,
		UserInfo,
		UserInfoDelete,
		UserInfoEdit,
		UserInfoEnable,
		GetUserCompany,
		BaOrganizationList,
		BaOrganizationInfo,
		GetUserCompanyRoles,
		SetUserCompanyRoles,
		InventoryClassList,
		GetUserInvClass,
		SetUserInvClass,
		UserInfoImportCusUserName,
		UserInfoDownloadCusUserNameTemplet,
		UserInfoImportUserInvClass,
		UserInfoDownloadUserInvClassTemplet,
		UserInfoResetPassword,
		UserInfoGetUserRole,
		UserInfoByInvClass,
		UserInfoAddUserInventory,
		UserInfoImport,
		UserInfoDownloadTemplet,
		GetUserInventory
	} from '@/api/home'
	export default {
		components: {
			Commontable,
			Commonbtn,
			Pagination,
			DialogFrom,
			Commondropdownlist,
			Dialog,
			CommonbtnUpLoad,
			Commondown
		},
		props: {
			total: {
				type: Number,
				default: 1
			},
			tableData: {
				type: Array,
				default: Array
			},
		},
		data: function() {
			return {
				optionaldeit: true,
				optionaldel: false,
				optionaladd: false,
				dialogVisibles: false,
				dialogVisiblesedit: false,
				dialogVisibledel: false,
				dialogVisiblestop: false,
				dialogVisiblessigningroles: false,
				dialogVisiblesassignproductline: false,
				dialogVisiblesasimportproductline: false,
				dialogVisiblesasjxsimportdealer: false,
				dialogVisiblechpassword: false,
				dialogVisiblesdrjg: false,
				dialogVisiblesproduct: false,
				rightboo: true,
				dwonleft: false,
				loading: false,
				stopoptional: true,
				rowboo: false,
				rowboos: false,
				options: [],
				boxsdata: [],
				boxsdatas: [],
				tableDatadrjg: [],
				qus: [],
				fromdataadd: [],
				fromdataedit: [],
				checkboxdata: [],
				checkboxdata2: [],
				ptype: '',
				userName: '',
				CompanyID: '',
				CompanyIDSet: '',
				title: '',
				CompanyNameTitle: '',
				CompanyNameSet: '',
				stopoptionalimg: require('@/assets/icon/qy.png'),
				stopoptionaltext: "启用",
				LicenseRList: [{
						title: '分配产品线',
						src: require('@/assets/icon/icon-fpcpx.png'),
						srcFlag: require('@/assets/icon/icon-fpcpx-s.png'),
						flag: false
					},
					{
						title: '分配角色',
						src: require('@/assets/icon/iocn-userfp.png'),
						srcFlag: require('@/assets/icon/iocn-userfp-s.png'),
						flag: false
					},
					{
						title: '新增产品',
						src: require('@/assets/icon/product.png'),
						srcFlag: require('@/assets/icon/product-s.png'),
						flag: true
					},
				],
				DowloadList: [{
					title: '下载账号编辑导入模版',
					flag: false
				}, ],
				fromdataproduct: [{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '495px',
						event: 'invClassChage',
						options: []
					},
					{
						inputdata: '',
						title: '产品',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'selectMultiple',
						width: '495px',
						options: []
					}
				],
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					assigninv: false
				},
				// InActive: '',//是否启用
				addfromData: {
					birthday: '',
					userName: '',
					trueName: '',
					address: '',
					email: '',
					gender: '',
					identityNo: '',
					isOperator: '',
					jobPost: '',
					mobile: '',
					remark: '',
					telephone: ''
				},

				headerData: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'UserName',
						label: '用户名',
						columnwidth: 130
					},
					{
						prop: 'TrueName',
						label: '姓名',
						columnwidth: 180
					},
					{
						prop: 'TrueName',
						label: '角色',
						columnwidth: 180
					},
					{
						prop: 'Gender',
						label: '性别',
						columnwidth: 180
					},
					{
						prop: 'Birthday',
						label: '出生日期',
						columnwidth: 180
					},
					{
						prop: 'InActive',
						label: '是否可用',
						columnwidth: 180
					},
					{
						prop: 'IsOperator',
						label: '是否操作员',
						columnwidth: 180
					},
					{
						prop: 'Creator',
						label: '创建人',
						columnwidth: 180
					},
				],
				headerData1: [{
						prop: 'id',
						label: '序号',
						columnwidth: 50
					},
					{
						prop: 'CompanyID',
						label: '组织代码',
						columnwidth: 120
					},
					{
						prop: 'CompanyName',
						label: '所属组织名称',
						columnwidth: 300
					},
				],
				tableData1: [],
			}
		},
		created() {},
		mounted() {
			this.fromdataadd = JSON.parse(JSON.stringify(fromdata))
			this.fromdataedit = JSON.parse(JSON.stringify(fromdataedit))
			this.QX()
		},
		methods: {
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus.map((item, index) => {
					if (item.NodeID == 1) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 2) {
								this.qus = items.Nodes
							}
						})
					}
				})
				this.qus.map((item, index) => {
					if (item.NodeName == 'add') {
						this.qx.add = true
					} else if (item.NodeName == 'edit') {
						this.DowloadList[0].flag = true
						this.qx.update = true
					} else if (item.NodeName == 'delete') {
						this.qx.del = true
					} else if (item.NodeName == 'stopif') {
						this.qx.del = true
					} else if (item.NodeName == 'assignment') {
						this.qx.assignment = true
					} else if (item.NodeName == 'enabled') {
						this.qx.enabled = true
					} else if (item.NodeName == 'assigninv') {
						this.qx.assigninv = true
					}
				})
				this.LicenseRList[0].flag = this.qx.assignment
				this.LicenseRList[1].flag = this.qx.assignment
				// this.LicenseRList[2].flag = this.qx.assigninv

				//console.log("qux", this.qus)
			},
			assigningrolesOrAssignproductlineClick(index) {
				if (index == 0) {
					this.assignproductline()
				} else if (index == 1) {
					this.assigningroles()
				} else if (index == 2) {
					if (this.rowboo == true) {
						this.dialogVisiblesproduct = true
						this.inventoryClassList('2')
						return
					}
					this.$message({
						type: 'error',
						message: '请选择您要操作的数据'
					})
				}
			},
			// 选择产品线然后获取商品名称
			invClassChage(e) {
				console.log(e.modelvalue, 'e6666666');
				this.userInfoByInvClass(e.modelvalue)
			},
			// 获取产品线列表
			async userInfoByInvClass(invClass) {
				let {
					code,
					data
				} = await UserInfoByInvClass({
					invClass: invClass
				})
				if (code == 0) {
					this.fromdataproduct[1].options = [];
					data.map((item, index) => {
						let obj = {
							key: item,
							value: item,
						};
						this.fromdataproduct[1].options.push(obj);
					});
				}
				let res = await GetUserInventory({
					invClass: invClass,
					userName: this.userName,
				})

				this.fromdataproduct[1].inputdata = res.data;
				console.log(res.data);
			},
			async userInfoAddUserInventory() {
				let {
					code,
					data,
					message
				} = await UserInfoAddUserInventory({
					userName: this.userName,
					invClass: this.$refs.AddProductRef[0].modelvalue,
					invNames: this.$refs.AddProductRef[1].modelvalue,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					})
					this.dialogVisiblesproduct = false
				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},
			cancelproduct() {
				this.dialogVisiblesproduct = false
			},
			dialogOKproduct() {
				this.userInfoAddUserInventory()
			},
			// 新增
			async UserInfoadd(datalist) {
				let {
					code,
					message
				} = await UserInfoAdd({
					userName: datalist[0].modelvalue,
					trueName: datalist[1].modelvalue,
					address: datalist[9].modelvalue,
					birthday: this.addfromData.birthday,
					email: datalist[8].modelvalue,
					gender: Number(datalist[3].radios),
					identityNo: datalist[5].modelvalue,
					isOperator: Number(datalist[10].radios),
					jobPost: datalist[2].modelvalue,
					mobile: datalist[7].modelvalue,
					emark: datalist[11].modelvalue,
					telephone: datalist[6].modelvalue
				})
				this.dialogVisibles = false
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '添加成功'
					});
					this.$parent.userInfoList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
				this.$refs.add.map((item, index) => {
					item.modelvalue = ''
				})
				//console.log(code, message)
			},
			// 详情
			async userInfo() {

				let {
					data,
					code
				} = await UserInfo({
					userName: this.addfromData.userName,
				})
				if (code == 0) {
					fromdataedit[0].inputdata = data.UserName
					fromdataedit[1].inputdata = data.TrueName
					fromdataedit[2].inputdata = data.JobPost
					fromdataedit[3].radio = data.Gender + ""
					fromdataedit[4].inputdata = data.Birthday
					fromdataedit[5].inputdata = data.IdentityNo
					fromdataedit[6].inputdata = data.Telephone
					fromdataedit[7].inputdata = data.Mobile
					fromdataedit[8].inputdata = data.Email
					fromdataedit[9].inputdata = data.Address
					fromdataedit[10].radio = data.IsOperator + ""
					fromdataedit[11].inputdata = data.Remark
					// fromdataedit[12].inputdata = data.Remark
					this.fromdataedit = fromdataedit

				}
			},
			// 修改
			async userInfoEdit(datalist) {
				let {
					code,
					message
				} = await UserInfoEdit({
					userName: datalist[0].modelvalue,
					trueName: datalist[1].modelvalue,
					address: datalist[9].modelvalue,
					birthday: this.addfromData.birthday,
					email: datalist[8].modelvalue,
					gender: Number(datalist[3].radios),
					identityNo: datalist[5].modelvalue,
					isOperator: Number(datalist[10].radios),
					jobPost: datalist[2].modelvalue,
					mobile: datalist[7].modelvalue,
					emark: datalist[11].modelvalue,
					telephone: datalist[6].modelvalue
				})
				this.dialogVisiblesedit = false
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '修改成功'
					});
					this.$parent.userInfoList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 删除
			async userDel() {
				let {
					code,
					message
				} = await UserInfoDelete({
					userName: this.addfromData.userName,
				})
				this.dialogVisibledel = false
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '删除成功'
					});
					this.$parent.userInfoList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 停用
			async userstop(InActive) {
				let {
					code,
					message
				} = await UserInfoEnable({
					userName: this.addfromData.userName,
					InActive: InActive
				})
				this.dialogVisiblestop = false
				this.$parent.userInfoList();
				if (code == 0) {
					this.$message({
						type: 'success',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 获取用户组织列表
			async getUserCompany() {
				let {
					code,
					data
				} = await GetUserCompany({
					userName: this.userName,
				})

				if (code == 0) {
					if (data.data) {
						this.tableData1 = data.data
						if (this.tableData1.length >= 1) {
							this.optionaladd = true
						}
					}
				}
			},
			// 获取角色列表
			async rolesList() {
				let {
					code,
					data
				} = await RolesList({

				})

				if (code == 0) {
					let arr = []
					data.data.map((item, index) => {
						let obj = {
							label: item.RID,
							value: item.RoleName
						}
						arr.push(obj)
					})
					//console.log('arr', arr)
					this.checkboxdata = arr
				}
			},
			// (右侧下拉框)一级经销商档案=>列表
			async remoteHosType(qurey) {
				this.loading = true
				let {
					code,
					data
				} = await BaOrganizationList({
					showAllOrganization: 1,
					CompanyName: qurey
				})

				if (code == 0) {
					if (data.data) {
						let arr = []
						data.data.map((item, index) => {
							let obj = {
								key: item.CompanyID,
								value: item.CompanyName
							}
							arr.push(obj)
						})
						this.options = arr
						//console.log(this.options, "options");
						this.loading = false
					}
				}
			},
			// 获取分配角色
			async getUserCompanyRoles() {
				let {
					code,
					data
				} = await GetUserCompanyRoles({
					UserName: this.userName,
					CompanyID: this.CompanyID
				})

				if (code == 0) {
					if (data) {
						this.boxsdata = data
					}
				}
			},
			// 修改分配角色
			async setUserCompanyRoles(CompanyID) {
				// console.log(CompanyID,this.CompanyNameSet);
				// if (CompanyID == this.CompanyNameSet) {
				//   this.$message({
				//     type: 'warning',
				//     message: '您修改数据与修改前数据一致'
				//   })
				//   return
				// }
				// this.CompanyNameSet = data.CompanyName
				// this.CompanyIDSet = data.CompanyID
				// this.$refs.suptselect.modelvalue = data.CompanyName
				let {
					code,
					message
				} = await SetUserCompanyRoles({
					UserName: this.userName,
					CompanyID: this.$refs.suptselect.modelvalue == this.CompanyNameSet ? this.CompanyIDSet :
						this.$refs.suptselect.modelvalue,
					roles: this.boxsdata,
				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '角色分配成功'
					});
					this.rightboo = false
					this.optionaldeit = false
					this.getUserCompanyRoles()
					this.getUserCompany()
					this.$parent.userInfoList()
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 获取产品线列表
			async inventoryClassList(way) {
				let {
					code,
					data
				} = await InventoryClassList({
					IsLeaf: 1
				})
				if (code == 0) {
					if (way == '1') {
						this.checkboxdata2 = []
						data.data.map((item, index) => {
							let obj = {
								label: item.InvClass,
								value: item.InvClassName,
							}
							this.checkboxdata2.push(obj)
						})
						//console.log(this.checkboxdata2)
					}
					if (way == '2') {
						this.fromdataproduct[0].options = []
						data.data.map((item, index) => {
							let obj = {
								key: item.InvClass,
								value: item.InvClassName,
							}
							this.fromdataproduct[0].options.push(obj)
						})

						//console.log(this.checkboxdata2)
					}

				}
			},
			// 获取产品线列表
			async getUserInvClass() {
				let {
					code,
					data
				} = await GetUserInvClass({
					UserName: this.addfromData.userName
				})
				if (code == 0) {
					//console.log(data, 'data');
					this.boxsdatas = data
				}
			},

			// 修改产品线列表
			async setUserInvClass() {
				let {
					code,
					message
				} = await SetUserInvClass({
					UserName: this.addfromData.userName,
					InvClasses: this.boxsdatas

				})
				if (code == 0) {
					this.$message({
						type: 'success',
						message: '产品线分配成功'
					});
					this.$parent.userInfoList();
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 导出
			Export() {
				this.$emit('Export')
			},
			// 导入
			async UserInfoImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '导入中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await UserInfoImport(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})

						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					this.$parent.CusRelationHospitalList()
					loading.close();
				}
			},
			//导入
			Import(file) {
				this.UserInfoImport(file)
			},
			// 下载导入模板
			async UserInfoDownloadTemplet() {
				// 测试
				// this.downURL = "https://bs.oudot.cn/Download/入库单导入模板(一级经销商).xlsx"
				let {
					data,
					code,
					message
				} = await UserInfoDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//下载模板
			Dowload(index) {
				if (index == 0) {
					this.UserInfoDownloadTemplet()
				}
			},
			async userInfoDownloadCusUserNameTemplet() {
				let {
					data,
					code,
					message
				} = await UserInfoDownloadCusUserNameTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载经销商账号导入模板
			SyDowload() {
				this.userInfoDownloadCusUserNameTemplet()
			},
			// 导入经销商账号
			async userInfoImportCusUserName(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await UserInfoImportCusUserName(formData)
					if (res.code == 0) {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			// 导入经销商账号
			SyImport(file) {
				this.userInfoImportCusUserName(file)
			},
			async userInfoDownloadUserInvClassTemplet() {
				let {
					data,
					code,
					message
				} = await UserInfoDownloadUserInvClassTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			// 下载用户产品线模板
			SyDowloadInv() {
				this.userInfoDownloadUserInvClassTemplet()
			},
			// 导入产品线账号
			async userInfoImportUserInvClass(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await UserInfoImportUserInvClass(formData)
					if (res.code == 0) {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'success',
							message: res.message
						})
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			SyImportInv(file) {
				this.userInfoImportUserInvClass(file)
			},
			// 重置密码
			async userInfoResetPassword() {
				let {
					code,
					data,
					message
				} = await UserInfoResetPassword({
					UserName: this.userName
				})
				if (code == 0) {
					this.$message({
						type: "success",
						message: message
					})
					this.rowboo == false
				} else {
					this.$message({
						type: "error",
						message: message
					})
				}
			},
			applicationclick() {
				this.setUserCompanyRoles(this.$refs.suptselect.modelvalue)
			},
			NOapplicationclick() {
				this.rightboo = false
				this.optionaldeit = false
				this.getUserCompanyRoles()
			},
			change3(val) {
				this.addfromData.birthday = val
				//console.log(val)
			},
			handleCurrentChange(pageindex) {
				this.$emit('handleCurrentChange', pageindex)
			},
			handleSizeChange(paegSzie) {
				this.$emit('handleSizeChange', paegSzie)
			},
			onRowClick(val) {
				this.rowboo = true
				this.CompanyNameTitle = val.CompanyName
				console.log(val, "hahahahh")
				this.userName = val.UserName
				// this.InActive = val.InActive
				if (val.InActive == 0) {
					this.stopoptionaltext = "启用"
					// this.stopoptional = true
					this.stopoptionalimg = require('@/assets/icon/qy.png')
				} else {
					this.stopoptionaltext = "停用"
					this.stopoptionalimg = require('@/assets/icon/icon-stop.png')
					// this.stopoptional = false
				}
				// if(val.CanAssignInvName == 1){
				//   this.LicenseRList[2].flag = true
				// } else if(val.CanAssignInvName == 0){
				//   this.LicenseRList[2].flag = false
				// }

				this.addfromData.userName = val.UserName

			},
			async baOrganizationInfo(companyID) {
				let {
					code,
					data,
					message
				} = await BaOrganizationInfo({
					companyID: companyID
				})
				if (code == 0) {
					this.CompanyNameSet = data.CompanyName
					this.CompanyIDSet = data.CompanyID
					this.$refs.suptselect.modelvalue = data.CompanyName

				} else {
					this.$message({
						type: 'error',
						message: message
					})
				}
			},

			onRowClickfp(val) {
				this.rowboos = true
				this.CompanyID = val.CompanyID
				this.baOrganizationInfo(val.CompanyID)

				// if (this.rowboos = true) {
				//   this.$refs.suptselect.options.map((item, index) => {
				//     if (item.value == val.CompanyID) {
				//     }
				//   })


				// }
				this.getUserCompanyRoles()
				this.optionaldeit = false
				//console.log(val, "hahahahh")
			},
			signeditclick() {
				if (this.rowboos = true) {
					this.optionaldeit = true
					this.rightboo = true
				}
			},
			Addclick() {
				this.optionaldeit = true
				this.optionaldel = false
				this.optionaladd = true
				this.rightboo = true

			},
			signclaceclick() {
				this.dialogVisiblessigningroles = false
			},
			adduser() {
				this.dialogVisibles = true
			},
			cancel() {
				this.dialogVisibles = false
			},
			// 新增
			dialogOK() {
				//console.log(this.$refs.add, "add")
				this.userName = this.$refs.add[0].modelvalue
				this.trueName = this.$refs.add[1].modelvalue
				this.address = this.$refs.add[9].modelvalue
				this.email = this.$refs.add[8].modelvalue
				this.gender = this.$refs.add[3].radio
				this.identityNo = this.$refs.add[5].modelvalue
				this.isOperator = this.$refs.add[10].radio
				this.jobPost = this.$refs.add[2].modelvalue
				this.mobile = this.$refs.add[7].modelvalue
				this.remark = this.$refs.add[11].modelvalue
				this.telephone = this.$refs.add[6].modelvalue
				this.UserInfoadd(this.$refs.add)

			},
			update() {
				if (this.rowboo == true) {
					this.dialogVisiblesedit = true
					this.userInfo()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要修改的数据！'
				});

			},
			canceledit() {
				this.dialogVisiblesedit = false
			},
			dialogOKedit() {

				this.userInfoEdit(this.$refs.update)
			},
			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},
			del() {
				if (this.rowboo == true) {
					this.dialogVisibledel = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要删除的数据！'
				});
			},
			canceldel() {
				this.dialogVisibledel = false
			},
			dialogOKdel() {
				this.userDel()

			},
			stop() {
				if (this.rowboo == true) {

					this.dialogVisiblestop = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要停用的数据！'
				});

			},
			handleCheckedCitiesChange(val) {
				this.boxsdata = val
				//console.log(val, 'val')
			},
			handleCheckedCitiesChangecpx(val) {
				this.boxsdatas = val
				//console.log(val, 'boxsdatas')
			},
			// 导入
			importproductline() {

			},
			importdealer() {

			},
			cancelstop() {
				this.dialogVisiblestop = false
			},
			dialogOKstop() {
				if (this.stopoptionaltext == "启用") {
					this.userstop(1)
				}
				if (this.stopoptionaltext == "停用") {
					this.userstop(0)
				}
			},
			assigningroles() {
				if (this.rowboo == true) {
					this.optionaldeit = true
					this.optionaldel = false
					this.optionaladd = false
					this.rightboo = false
					this.boxsdata = []
					this.dialogVisiblessigningroles = true
					this.getUserCompany()
					this.rolesList()
					// this.baOrganizationList()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要分配角色的数据！'
				});
			},
			cancelsigningroles() {

				this.dialogVisiblessigningroles = false
			},
			dialogOKsigningroles() {

				this.dialogVisiblessigningroles = false
			},
			assignproductline() {

				if (this.rowboo == true) {
					this.dialogVisiblesassignproductline = true
					this.inventoryClassList('1')
					this.getUserInvClass()
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要分配的用户！'
				});

			},
			canceldialogVisiblesassignproductline() {
				this.dialogVisiblesassignproductline = false
			},
			dialogOKdialogVisiblesassignproductline() {
				this.setUserInvClass()
				this.dialogVisiblesassignproductline = false
			},
			canceldialogVisiblesasimportproductline() {
				this.dialogVisiblesasimportproductline = false
			},
			dialogOKdialogVisiblesasimportproductline() {
				this.dialogVisiblesasimportproductline = false
			},
			importdealerbtn() {
				this.dialogVisiblesasjxsimportdealer = true
			},
			canceldialogVisiblesasjxsimportdealer() {
				this.dialogVisiblesasjxsimportdealer = false
			},
			dialogOKdialogVisiblesjxsasimportdealer() {
				this.dialogVisiblesasjxsimportdealer = false
			},
			czpassword() {
				if (this.rowboo == true) {
					this.dialogVisiblechpassword = true
					return
				}
				this.$message({
					type: 'error',
					message: '请选择要重置密码的用户！'
				});
			},
			cancelpassword() {
				this.dialogVisiblechpassword = false
			},
			dialogOKpassword() {
				this.userInfoResetPassword()
				this.dialogVisiblechpassword = false
			},
			dwonlist() {
				this.dwonleft = !this.dwonleft
			},
			downclick() {
				this.dwonleft = false
				this.dialogVisiblesasimportproductline = true
			}
		}
	}
</script>

<style lang="less" scoped>
	.incenters {
		height: 100%;

		.pagination {
			display: flex;
			justify-content: center;
			align-items: center;
		}

		// div {
		//   margin-left: 8px;
		//   margin-right: 8px;
		//   margin-top: 5px;
		//   margin-bottom: 5px;

		// }
		.from {
			width: 100%;
		}
	}

	.signingrolesStyle {
		height: 500px;
		width: 100%;
		// display: flex;
		// justify-content: space-between;
		// align-items: center;

		.left {
			height: 300px;
			width: 470px;
			border: 1px solid #e6e6e6;
		}

		.right {
			height: 300px;
			width: 470px;
			border: 1px solid #e6e6e6;
			// pointer-events: none;
		}
	}

	.right-s {
		position: relative;
		z-index: 99;
		opacity: 0.5;
		right: -486px;
		width: 485px;
		height: 300px;
		background-color: #ffffff;
		cursor: no-drop;
	}

	.dwonleft {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		margin-left: 980px;
		margin-top: 0px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		opacity: 1;
		transition: all 0.3s;
	}

	.dwonlefts {
		width: 170px;
		height: 48px;
		position: absolute;
		background-color: #ffffff;
		z-index: 99;
		margin-left: 980px;
		margin-top: -20px;
		text-align: center;
		line-height: 48px;
		color: #333333;
		box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
			0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12);
		border-radius: 2px;
		font-size: 14px;
		cursor: pointer;
		user-select: none;
		opacity: 0;
		transition: all 0.3s;
		pointer-events: none;
	}

	.dwonleft:hover {
		background-color: #f0f0f0;
	}
</style>